import { render, staticRenderFns } from "./OtherIncomeYN.vue?vue&type=template&id=cd4df526"
import script from "./OtherIncomeYN.vue?vue&type=script&lang=js"
export * from "./OtherIncomeYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports